import React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import './InputFieldsComponent.css';
import InfoBar from '../InfoBars';
import CustomTooltip from '../CustomTooltip';
import EditIcon from '../../../assets/svg_main/edit_outline.svg'
interface InputFieldProps {
  placeholder: string;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  type: string; //text | email | password |
  isDisabled: boolean;
  className?: string;
  labelName?: string;
  required?: boolean;
  onChange: (value: string,event?:any) => void;
  value?: any;
  maximumLength?: number ;
  inputId?:any;
  errorMessage?:string;
  disablePastDates?:boolean;
  maxDate?:string;
  minDate?:string;
  onClick?:()=>void;
  tooltipNeeded?:boolean;
  toolTipText?:string;
  onkeydown?:any;
  showEditIcon?:boolean;
  onInputFieldEditIconClick?:any;
}
const InputFieldsSmallComponent = ({
  inputType = 'general',
  placeholder,
  type,
  isDisabled,
  className,
  labelName,
  required,
  onChange,
  value,
  maximumLength,
  inputId,
  errorMessage,
  disablePastDates,
  maxDate,
  minDate,
  onClick,
  tooltipNeeded,
  toolTipText,
  onkeydown,
  showEditIcon,
  onInputFieldEditIconClick
}: InputFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value,e);
  };
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'number' && maximumLength !== undefined && e.target.value.length > maximumLength) {
      e.target.value = e.target.value.slice(0, maximumLength);
    }
        if (type === 'text') {
      if (className === 'lattitude' || className === 'longitude') {
        const regex = /^(-?\d{0,3}\.\d*),(-?\d{0,3}\.\d*)$/;
        if (!regex.test(e.target.value)) {
          const lastChar = e.target.value[e.target.value.length - 1];
          if (!/[\d.,-]/.test(lastChar)) {
            e.target.value = e.target.value.slice(0, -1);
          }
        }
       }
      else if (className === 'pincode') {
        if (!/^\d{0,6}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
      else if (className === 'mob' || className === 'a_mob' ) {
        if (!/^\d{0,10}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
      else if (className === 'abhaNumber' ) {
        if (!/^\d{0,14}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
      else if (className === 'sanctionedbed_count' || className === 'functionalbed_count' ) {
        if (!/^\d{0,4}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
    }
    else if(type==='password'){
       if (className === 'PIN') {
        if (!/^\d{0,6}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
    }
  };
  const getCurrentDate = () => {
    return new Date().toISOString().slice(0, 10);
  };
  const onEditHandle=()=>{
    showEditIcon && onInputFieldEditIconClick();
  }
  return (
    <div className={`input-field-container  ${className}`}>
      {labelName && (
        <label
          className={`label-name-from-parent ${required && 'yes'} ${isDisabled}`}
        >
          {labelName}
          {tooltipNeeded &&
          <span className='tooltip-profile-pic'><CustomTooltip text={toolTipText}/></span>
          }
        </label>
      )}
      <InputGroup
        className={` input-field-group input-field-group-${inputType}`}
        onClick={()=>{
          if(onClick){
            onClick();
          }
        }}
      >
        <FormControl
          placeholder={placeholder}
          aria-label="Search"
          className={`text-bar-input ${isDisabled} ${type === 'number' ? 'no-spinner' : ''}`}
          type={type}
          disabled={isDisabled}
          onChange={handleChange}
          value={value}
          maxLength={maximumLength}
          id={inputId}
          onInput={handleInput}
          min={type==='date' ? minDate : undefined}
          max={type==='date' ? maxDate : undefined}
          onKeyDown={(e) => {if(onkeydown) {onkeydown(e)}}}
        />
        {showEditIcon && <span className='input_fields_edit_icon_class'>
          <EditIcon onClick={onEditHandle} />
        </span>}
      </InputGroup>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default InputFieldsSmallComponent;
